module.exports = __webpack_public_path__ + "img/icon_card010.951f4e61.png";